// extracted by mini-css-extract-plugin
export default {"tasks":"IK-z","task":"JK-z","svg":"KK-z","text":"LK-z"};